import React from 'react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { computerColor, tabletColor, mobileColor, connectedTVColor } from '../constants/device-color';
import { getStyles } from '../styles/devices-comparison-card';

const patterns = [
  { id: 'pattern1', color: computerColor, path: 'M 3 0 L 3 10' },
  { id: 'pattern2', color: tabletColor, path: 'M 3 0 L 3 10' },
  { id: 'pattern3', color: mobileColor, path: 'M 3 0 L 3 10' },
  { id: 'pattern4', color: connectedTVColor, path: 'M 3 0 L 3 10' },
];

export const DeviceComparisonPatterns: React.FC = () => {
  const styles = useDefaultStyles(getStyles);

  return (
    <svg className={styles.comparisonCardPattern}>
      <defs>
        {patterns.map(pattern => (
          <pattern
            id={pattern.id}
            key={pattern.id}
            width="6"
            height="6"
            patternUnits="userSpaceOnUse"
          >
            <line x1="0" y1="0" x2="0" y2="10" stroke={pattern.color} strokeWidth="6" />
          </pattern>
      ))}
      </defs>
    </svg>
  );
};
